import React, { Component } from 'react'
import {
  Segment,
  Card,
  Header,
  Grid,
  Icon,
  Button,
  Modal,
  List,
  Form,
  Dimmer,
  Divider,
  Loader,
  Label,
} from 'semantic-ui-react'
import _ from 'lodash'
import NameField from './fields/nameField'
import FeeTypeField from './fields/feeTypeField'
import DescriptionField from './fields/descriptionField'
import GoToField from './fields/feeGoToField'

const initData = {
  key: '',
  name: '',
  description: '',
  type: '',
  go_to: '',
}

class DynamicFee extends Component {
  btnSubmitRef = React.createRef()

  constructor(props) {
    super(props)

    this.state = {
      visible: false,
      action: 'new',
      dynamicFeeData: {},
    }
  }

  onFieldChange = (field, value) => {
    let { dynamicFeeData } = this.state

    dynamicFeeData = {
      ...dynamicFeeData,
      [field]: value,
    }

    this.setState({ dynamicFeeData })
  }

  handleAddClick = () => {
    this.setState({
      visible: true,
      action: 'new',
      dynamicFeeData: initData,
    })
  }

  onClose = () => {
    this.setState({ visible: false })
  }

  onEdit = dynamicFeeData => {
    this.setState({
      visible: true,
      action: 'edit',
      dynamicFeeData,
    })
  }

  onDelete = feeKey => {
    const { deleteDynamicFee } = this.props
    const confirm = window.confirm('Are you sure you want to delete?')

    if (confirm) {
      deleteDynamicFee(feeKey)
    }
  }

  submitForm = () => {
    const { saveDynamicFee } = this.props
    const { dynamicFeeData } = this.state

    saveDynamicFee(dynamicFeeData, () => {
      this.onClose()
    })
  }

  renderDynamicFee = () => {
    const { dynamicFees } = this.props

    return _.map(dynamicFees, (dynamicFee, key) => (
      <Card key={key}>
        <Card.Content>
          <Card.Header>{dynamicFee.name}</Card.Header>
          <Card.Description>
            <Divider />
            <List>
              <List.Item>
                Type:
                <Label style={{ marginLeft: 5 }} color="orange">
                  {dynamicFee.type}
                </Label>
              </List.Item>
              <List.Item>
                Go To:
                <Label style={{ marginLeft: 5 }}>{dynamicFee.go_to}</Label>
              </List.Item>
              <List.Item>{dynamicFee.description}</List.Item>
            </List>
          </Card.Description>
        </Card.Content>
        <Card.Content extra style={{ textAlign: 'right' }}>
          <Button onClick={() => this.onEdit(dynamicFee)} icon="edit" />
          <Button color="red" onClick={() => this.onDelete(key)} icon="trash" />
        </Card.Content>
      </Card>
    ))
  }

  renderForm = () => {
    const { addingDynamicFee } = this.props
    const { visible, action, dynamicFeeData } = this.state

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content={action === 'new' ? 'Add New Dynamic Fee' : 'Edit Dynamic Fee'} />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form
            onSubmit={this.submitForm}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={addingDynamicFee}
          >
            <Form.Group widths="equal">
              <NameField
                onChange={this.onFieldChange}
                value={dynamicFeeData.name}
                field="name"
                label="Name"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <FeeTypeField onChange={this.onFieldChange} value={dynamicFeeData.type} />
            </Form.Group>
            <Form.Group widths="equal">
              <GoToField onChange={this.onFieldChange} value={dynamicFeeData.go_to} />
            </Form.Group>
            <Form.Group widths="equal">
              <DescriptionField onChange={this.onFieldChange} value={dynamicFeeData.description} />
            </Form.Group>
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onClose} disabled={addingDynamicFee}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={addingDynamicFee}
            disabled={addingDynamicFee}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }

  render() {
    const { dynamicFeeLoading } = this.props

    return (
      <div style={{ margin: '16px 0' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Header style={{ margin: 0 }}>Dynamic Fee</Header>
          <Button icon color="black" onClick={this.handleAddClick}>
            <Icon name="add" /> Add New Dynamic Fee
          </Button>
        </div>
        <Segment style={{ height: 'calc(100vh - 265px)', overflow: 'auto' }}>
          <Grid.Row>
            <Card.Group itemsPerRow={3} style={{ marginTop: 0 }}>
              {dynamicFeeLoading ? (
                <Dimmer active inverted style={{ margin: 30 }}>
                  <Loader inverted content="Loading" />
                </Dimmer>
              ) : (
                this.renderDynamicFee()
              )}
            </Card.Group>
          </Grid.Row>
        </Segment>
        {this.renderForm()}
      </div>
    )
  }
}

export default DynamicFee



// WEBPACK FOOTER //
// ./src/components/restaurants/dynamicFee.js